import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Inject, OnInit } from '@angular/core';
import { MODAL_DEFINITION } from '../../inection-tokens';
import { ModalWindowWrapper } from '../../models';
import { CdkPortalService } from '../../services/cdk-portal-service/cdk-portal.service';

@Component({
  selector: 'app-modal-host',
  templateUrl: './modal-host.component.html',
  styleUrls: ['./modal-host.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalHostComponent implements OnInit {
  /**
   * Will assign id for host element in case window object contains value for id.
   * Usefull when we need to specify custom styles for modal window related things.
   */
  @HostBinding('attr.id')
  private get id(): string {
    return this.modalWindowWrapper.modalWindow?.id;
  }

  get modalType(): 'center' | 'right-panel' {
    switch (true) {
      case (this.modalWindowWrapper.type === 'center'):
        return 'center';
      case this.modalWindowWrapper.type.startsWith('right'):
      case this.modalWindowWrapper.type.startsWith('w-'):
        return 'right-panel';
    }
  }

  constructor(
    private cdkPortalService: CdkPortalService,
    private elementRef: ElementRef<HTMLElement>,
    @Inject(MODAL_DEFINITION) public modalWindowWrapper: ModalWindowWrapper,
  ) {}

  ngOnInit(): void {
    this.findCdkOverlayPane().classList.add('modal-overlay-pane');
  }

  closeModal(): void {
    this.cdkPortalService.setDirection('closing');
    this.cdkPortalService.closePortal();

    if (this.modalWindowWrapper.modalWindow.options?.onClose) {
      this.modalWindowWrapper.modalWindow.options.onClose(false);
    }
  }

  private findCdkOverlayPane(): HTMLElement {
    function recursiveFind(element: HTMLElement): HTMLElement {
      if (element.classList.contains('cdk-overlay-pane')) {
        return element;
      }

      return recursiveFind(element.parentElement);
    }

    return recursiveFind(this.elementRef.nativeElement);
  }
}
